import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Tooltip, { POSITION } from 'gnos-tooltip'
import cx from 'classnames'
import _ from 'lodash'

import Signals from '../../../../../../../../../../components/TableCell/components/Signals'
import ContextBurger from '../../../../../../../../../../components/ContextBurger'
import Minireport from '../../../../../../../../../../components/Minireport'

import './style.scss'

export default class RoleEntity extends Component {
    static propTypes = {
        block: PropTypes.string,
        customData: PropTypes.object.isRequired,
        entity: PropTypes.object.isRequired,
        indicators: PropTypes.object,
        mainId: PropTypes.string.isRequired,
        module: PropTypes.string,
        openSections: PropTypes.object,
        tableIdentifier: PropTypes.string.isRequired,
        toggleRoleSection: PropTypes.func.isRequired,
        translates: PropTypes.shape({
            birthDateLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
        }).isRequired,
        type: PropTypes.string,
    }

    static defaultProps = {
        type: 'primary',
    }

    handleToggleRoleSection = () => {
        const { module, block, customData, toggleRoleSection, tableIdentifier, mainId } = this.props

        const isOpen = _.get(customData, `openSections.${tableIdentifier}`, false)
        const newCustomData = {
            openSections: {
                ...customData.openSections,
                [tableIdentifier]: !isOpen,
            },
        }

        toggleRoleSection(module, mainId, block, newCustomData)
    }

    renderContent = () => {
        const { type, entity } = this.props

        return type === 'primary' ? (
            <div className={'role-entity-content'}>
                <div className={cx('role-name')}>
                    <span>{_.get(entity, 'name', null)}</span>
                    {!_.isNil(_.get(entity, 'countryIso')) && entity.countryIso !== 'CZ' && (
                        <div className={`flag-icon flag-icon-${_.toLower(entity.countryIso)}`} />
                    )}
                    <div className={'context-burger-container'}>
                        <ContextBurger entity={entity} id={_.get(entity, 'id', null)} />
                    </div>
                </div>
            </div>
        ) : (
            <div className={cx('role-entity-content', _.get(entity, 'inactive', false) && 'inactive')}>
                <strong className={cx('role-name')}>
                    {_.get(entity, 'name', null)}
                    <div className={'context-burger-container'}>
                        <ContextBurger entity={entity} id={_.get(entity, 'id', null)} />
                    </div>
                </strong>
                <div className={cx('role-address')}>
                    {_.get(entity, 'countryIso', '') !== 'CZ' && (
                        <div
                            className={cx('flag-icon', `flag-icon-${_.get(entity, 'countryIso', '').toLowerCase()}`)}
                        />
                    )}
                    <span>{_.get(entity, 'addressFull', null)}</span>
                </div>
            </div>
        )
    }

    render() {
        const { entity, type, getContextItems, tableIdentifier, openSections, indicators } = this.props

        const minireport = <Minireport id={`${_.get(entity, 'id', null)}`} />

        return getContextItems ? (
            <div className={cx('role-entity', type)}>
                <Tooltip
                    content={minireport}
                    id={`tooltip_minireport_roles_${_.get(entity, 'id', null)}`}
                    position={POSITION.TOP}
                    width={'320px'}
                    showDelay={1000}
                    doubleWrap
                >
                    <div>
                        <div className={'role-entity-icons'}>
                            <div
                                className={cx(
                                    'role-entity-icon',
                                    _.get(entity, 'type'),
                                    type,
                                    _.get(entity, 'inactive', false) && 'inactive'
                                )}
                            />
                            <div
                                className={cx(
                                    'role-toggle-icon',
                                    !openSections?.[tableIdentifier] ? 'open' : 'close',
                                    type
                                )}
                                onClick={this.handleToggleRoleSection}
                            />
                            <div className={cx('role-navigation-icon')} />
                        </div>
                        {this.renderContent()}
                    </div>
                </Tooltip>
                {type !== 'primary' && (
                    <div className={'signals-container'}>
                        <Signals
                            id={_.get(entity, 'id', null)}
                            caution={_.get(indicators, 'caution', 0)}
                            notice={_.get(indicators, 'notice', 0)}
                            risk={_.get(indicators, 'risk', 0)}
                            showZeroValues={false}
                        />
                    </div>
                )}
            </div>
        ) : (
            <div className={cx('role-entity', type)}>
                <Tooltip
                    content={minireport}
                    id={`tooltip_minireport_roles_${_.get(entity, 'id', null)}`}
                    position={POSITION.TOP}
                    width={'230px'}
                    showDelay={2000}
                    doubleWrap
                >
                    <div>
                        <div className={'role-entity-icons'}>
                            <div
                                className={cx(
                                    'role-entity-icon',
                                    _.get(entity, 'type'),
                                    type,
                                    _.get(entity, 'inactive', false) && 'inactive'
                                )}
                            />
                            <div
                                className={cx(
                                    'role-toggle-icon',
                                    !openSections?.[tableIdentifier] ? 'open' : 'close',
                                    type
                                )}
                                onClick={this.handleToggleRoleSection}
                            />
                            <div className={cx('role-navigation-icon')} />
                        </div>
                        {this.renderContent()}
                    </div>
                </Tooltip>
                <div className={'signals-container'}>
                    {type !== 'primary' && (
                        <Signals
                            id={_.get(entity, 'id', null)}
                            caution={_.get(indicators, 'caution', 0)}
                            notice={_.get(indicators, 'notice', 0)}
                            risk={_.get(indicators, 'risk', 0)}
                            showZeroValues={false}
                        />
                    )}
                </div>
            </div>
        )
    }
}
